export const interestCreditDefaultTrueProgramName = 'TRUE TX CO';

export const MAX_INTEREST_CREDIT_EDITABLE_DAY_IN_MONTH = 10;
